import { createSlice } from '@reduxjs/toolkit'

// This state handles which course you are currently looking at on the page (eg. Functional Occlucion and Treatment Planning Course 165).
// It's updated on swiping the course swiper.
export const activeCourseNameSlice = createSlice({
  name: 'activeCourseName',
  initialState: {
    value: 'loading',
  },
  reducers: {
    // update the active course name
    changeActiveCourse: (state, action) => {
      state.value = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { changeActiveCourse } = activeCourseNameSlice.actions

export default activeCourseNameSlice.reducer